/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingSequentialMutationRequest, PostApiBookingSequentialMutationResponse, PostApiBookingSequentialQueryParams } from "../entities/PostApiBookingSequential";

function getPostApiBookingSequentialUrl() {
  const res = { method: 'POST', url: `/api/booking/sequential` as const }
  return res
}

/**
 * @description Создание последовательных записей для родителя и ребенка
 * @summary Создать последовательную запись
 * {@link /api/booking/sequential}
 */
export async function postApiBookingSequential(data: PostApiBookingSequentialMutationRequest, params: PostApiBookingSequentialQueryParams, config: Partial<RequestConfig<PostApiBookingSequentialMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBookingSequentialMutationResponse, ResponseErrorConfig<Error>, PostApiBookingSequentialMutationRequest>({ method : "POST", url : getPostApiBookingSequentialUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}